import { useEffect } from "react";
import { Navigate } from "react-router-dom";

const AdminRedirect = () => {
  useEffect(() => {
    // Redirect to the admin URL
    window.location.href = process.env.REACT_APP_ADMIN_URL;
  }, []);

  return null;
};

export default AdminRedirect;
